import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-heart-fill",
  templateUrl: "./med-icon-heart-fill.component.html",
})
export class MedIconHeartFillComponent extends SvgMixinComponent {}
